import { render, staticRenderFns } from "./ToolPinyin.vue?vue&type=template&id=2396d5bf&scoped=true"
import script from "./ToolPinyin.vue?vue&type=script&lang=js"
export * from "./ToolPinyin.vue?vue&type=script&lang=js"
import style0 from "./ToolPinyin.vue?vue&type=style&index=0&id=2396d5bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2396d5bf",
  null
  
)

export default component.exports